import {walletActionTypes} from './wallet.actionTypes';
import {GlobalScreens} from '../../../utils/globalConstant';
const initialState = {
  walletTransactionData: [],
  errors: undefined,
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case walletActionTypes.WALLET_TRANSACTION_LOAD: {
      return {...state, loading: true};
    }
    case walletActionTypes.WALLET_TRANSACTION_SUCCESS: {
      return {
        ...state,
        loading: false,
        walletTransactionData:
          action.payload.page === 1
            ? action.payload.transactions
            : [...state.walletTransactionData, ...action.payload.transactions],
        isPassBookDataAvailable:
          action.payload.transactions.length ===
          (GlobalScreens?.TxnPage?.txnLimit || 10),
      };
    }
    case walletActionTypes.WALLET_TRANSACTION_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    }
    case walletActionTypes.CONVERSION_RATE_LOAD: {
      return {...state, loading: true};
    }
    case walletActionTypes.CONVERSION_RATE_SUCCESS: {
      return {
        ...state,
        loading: false,
        conversionData: action.payload,
      };
    }
    case walletActionTypes.CONVERSION_RATE_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    }
    case walletActionTypes.SET_DEPOSIT_GST: {
      return {
        ...state,
        depositData: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export {reducer as walletReducer};
